import { Injectable, inject } from '@angular/core'
import {
  API_CONFIGURATION,
  ApiClient,
  ApiClientType,
  ApiErrorMapper,
  FullApiClientConfiguration,
  HttpClientRemoteData,
} from '@ftr/api-shared'
import { Region } from '@ftr/contracts/type/court'

/**
 * Create a client service for ftr-external-organization (API), for a given controller path and region.
 */
@Injectable({
  providedIn: 'root',
})
export class ExternalOrganizationApiClientFactory {
  private readonly http = inject(HttpClientRemoteData)
  private readonly config = inject<FullApiClientConfiguration>(API_CONFIGURATION)
  private readonly apiErrorMapper = inject(ApiErrorMapper)

  buildForRegion(path: string, region: Region, httpService: HttpClientRemoteData = this.http): ApiClient {
    return new ApiClient(
      httpService,
      this.config,
      this.apiErrorMapper,
      { clientType: ApiClientType.externalOrganization, region },
      `/${path.replace(/^\//, '')}`,
    )
  }
}
